


































































import store from "@/store";
import { CURRENCY } from "@/commons/enums";

export default {
  data() {
    return {
      currencies: Object.values(CURRENCY),
    };
  },
  computed: {
    loginUser() {
      return store.getters["auth/getLoginUser"];
    },
    isMobileDisplay(): boolean {
      return (
        (this as any).$vuetify.breakpoint.name === "xs" ||
        (this as any).$vuetify.breakpoint.name === "sm"
      );
    },
  },
  methods: {
    toggleSidebar() {
      (this as any).$emit("toggle");
    },
    switchLocale(value: string) {
      (this as any).$i18n.locale = value;
      (this as any).locale = value; // validationメッセージの言語切り替え
    },
    toHome() {
      (this as any).$router.push({ name: "Home" });
    },
    switchCurrency(value: string) {
      store.commit('setCurrency', value);
    }
  },
};
